import type { ButtonVariant } from '@/ui/buttons/button-styles/ButtonStyles'
import type { TypeIcons } from '@/ui/icons/icon/Icon'
import { z } from 'zod'

/**
 * Schema for Store Locator Button
 * Only requires variant, url and label are added dynamically on the frontend
 */
export const storeLocatorButtonSchema = z.object({
  variant: z.custom<ButtonVariant>().optional(),
  iconLeft: z.custom<TypeIcons>().optional(),
})

export type StoreLocatorButtonSchemaType = z.infer<typeof storeLocatorButtonSchema>
